import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useNavigate, useParams } from "react-router-dom";
import { useApiClient } from "../../../api";
import GeneralLoading from "../../../shared-components/Loading";
import Grid from "@mui/material/Grid";
import { FindClassAndAssignDialog } from "../components/FindClassAndAssignDialog";
import { InformationSnippet } from "../../../shared-components/InformationSnippet";
import { FruitifySchoolClassSearch } from "../../school/components/FruitifySchoolClassSearch";

export const TeacherSummary = ({ teacher }) => {
  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h3">Teacher information</Typography>
        </Stack>

        <Grid container spacing={2} direction={"row"} sx={{ mt: 2, mb: 2 }}>
          <Grid size={6}>
            <InformationSnippet title={"Name"} value={teacher.user.fullName} />
          </Grid>
          <Grid size={6}>
            <InformationSnippet title={"School"} value={teacher.school.name} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

function TeacherView() {
  const { id } = useParams();
  const ApiClient = useApiClient();
  const [possibleClasses, setPossibleClasses] = useState([]);
  const [teacher, setTeacher] = useState({});
  const [loading, setLoading] = useState(true);
  const [assignClassOpen, setAssignClassOpen] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchTeacher();
  }, [id]);

  const fetchTeacher = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await ApiClient.schools.getTeacher({
        teacher: id,
      });
      if (response) {
        setPossibleClasses(response.possibleClassesForTeacher);
        setTeacher(response.teacher);
      }
    } catch (error) {
      console.error("Failed to fetch teacher", error);
      setError(String(error));
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveClass = async (schoolClass) => {
    try {
      const response = await ApiClient.schools.removeTeachersFromClass({
        teachers: [teacher.id],
        schoolClass: schoolClass.id,
      });
      if (response.success) {
        fetchTeacher();
      } else {
        console.error("Failed to remove teacher");
      }
    } catch (error) {
      console.error("Failed to remove teacher", error);
    }
  };

  if (loading) {
    return <GeneralLoading />;
  }

  if (!Object.keys(teacher).length) {
    return <Typography>Unable to load Teacher data. {error}</Typography>;
  }
  return (
    <FruitifyContainer>
      <FindClassAndAssignDialog
        open={assignClassOpen}
        setOpen={setAssignClassOpen}
        schoolClasses={possibleClasses}
        teacher={teacher}
        onSuccess={fetchTeacher}
      />
      <TeacherSummary teacher={teacher} />
      <Grid container spacing={4} direction={"row"} sx={{ mt: 2 }}>
        <Grid item size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h5" fontWeight="bold">
              Classes
            </Typography>
            <Button
              variant="contained"
              onClick={() => setAssignClassOpen(true)}
            >
              Add Class
            </Button>
          </Box>
          <FruitifySchoolClassSearch
            possibleClasses={teacher.classes}
            onClassUnassignClicked={handleRemoveClass}
            onClassViewClicked={(schoolClass) =>
              navigate(`/management/classes/view/${schoolClass.id}`)
            }
          />
        </Grid>
      </Grid>
    </FruitifyContainer>
  );
}

export default TeacherView;
